import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { ParsedDate, parseIsoDate } from '@api/Trinium/types';

export interface TractorRaw {
	id: string;
	/** Contractor ID */
	ctrId: string;
	/** Plate Number */
	pltNo: string;
	/** Plate Expiration Date */
	pltExpDate: string;
	/** Inspection Expiration Date */
	inspDate: string;
	/** Default Driver ID */
	drvId: string;
}

type ExcludedRawTractorFields = 'pltExpDate' | 'inspDate';

export type Tractor = GridValidRowModel &
	Omit<TractorRaw, ExcludedRawTractorFields> & {
		plateExpirationDate: ParsedDate;
		inspectionDate?: ParsedDate;
	};

export function transformTractorResponse(response: TractorRaw[]) {
	return response.map((item) => {
		const { pltExpDate, inspDate, ...fields } = item;
		return {
			...fields,
			plateExpirationDate: parseIsoDate(pltExpDate),
			inspectionDate: parseIsoDate(inspDate)
		} as Tractor;
	});
}
